const digitsOnly = (value) => String(value || '').replace(/\D/g, '');

export const UF_OPTIONS = [
  'AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO',
];

export function formatCpfCnpj(value) {
  const digits = digitsOnly(value).slice(0, 14);
  if (digits.length <= 11) {
    if (digits.length !== 11) return digits;
    return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  if (digits.length !== 14) return digits;
  return digits.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export function brazilNationalPhone(value) {
  let digits = digitsOnly(value);
  if (digits.startsWith('55') && digits.length >= 12) digits = digits.slice(2);
  return digits.slice(0, 11);
}

export function normalizePhone(value, defaultDdi = '55') {
  const raw = String(value || '').trim();
  let digits = digitsOnly(raw);
  if (!digits) return `+${defaultDdi} `;

  // Para números brasileiros, 55 é DDI — nunca DDD. Isso cobre tanto
  // "5531997018872" quanto "+55 (31) 99701-8872".
  if (defaultDdi === '55' && digits.startsWith('55') && digits.length >= 12) {
    digits = digits.slice(2);
  }

  // Um + explícito com DDI diferente de 55 é preservado como internacional.
  if (raw.startsWith('+') && !digitsOnly(raw).startsWith(defaultDdi)) {
    return `+${digitsOnly(raw)}`;
  }

  const national = digits.slice(0, 11);
  if (national.length === 11) {
    return `+${defaultDdi} (${national.slice(0, 2)}) ${national.slice(2, 7)}-${national.slice(7)}`;
  }
  if (national.length === 10) {
    return `+${defaultDdi} (${national.slice(0, 2)}) ${national.slice(2, 6)}-${national.slice(6)}`;
  }
  return `+${defaultDdi} ${national}`.trimEnd();
}

export function formatCep(value) {
  const digits = digitsOnly(value).slice(0, 8);
  return digits.length === 8 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
}

export function normalizeUf(value) {
  return String(value || '').trim().toUpperCase().slice(0, 2);
}

export function normalizeBillingForStorage(billing) {
  return {
    ...billing,
    taxID: formatCpfCnpj(billing?.taxID),
    phone: normalizePhone(billing?.phone),
    address: {
      ...(billing?.address || {}),
      zipcode: formatCep(billing?.address?.zipcode),
      state: normalizeUf(billing?.address?.state),
    },
  };
}

export async function lookupCep(value) {
  const cep = digitsOnly(value);
  if (cep.length !== 8) return null;
  const response = await fetch(`https://brasilapi.com.br/api/cep/v1/${cep}`);
  if (!response.ok) return null;
  const data = await response.json();
  return {
    zipcode: formatCep(data?.cep || cep),
    street: data?.street || '',
    neighborhood: data?.neighborhood || '',
    city: data?.city || '',
    state: normalizeUf(data?.state || ''),
  };
}
